// `/app/international-withdrawals/$id`: link direto pra um saque em USDT (e-mail, suporte).
//
// O detalhe é uma gaveta POR CIMA da lista, e a lista é da rota-índice. Sem rota-pai no
// `files_allowed` da task não há `<Outlet/>` pra encaixar o detalhe (como `app.withdrawals`
// faz), então este caminho leva pro mesmo lugar: a rota-índice com `?id=`.

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/international-withdrawals/$id')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/app/international-withdrawals',
      search: { id: params.id },
      replace: true,
    });
  },
});
